import { getJrnDefaultComponent } from '../getJrn/getJrnDefaultComponent.js'
import getZohoUserController from './getZohoUserController.js'
import _module from 'module.js'
import _ from 'lodash'

let getZohoUserComponent = _.cloneDeep(getJrnDefaultComponent)
getZohoUserComponent.controller = getZohoUserController

_module.component('getZohoUser', getZohoUserComponent)
